import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Faz o scroll voltar ao topo a cada mudança de rota.
 * Respeita o "hash" (#anchor) — quando há hash, deixa o navegador fazer o scroll.
 * Considera contêineres internos com data-scroll-root (ex.: layouts com overflow-auto).
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // navegação para âncora
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch (_) {
      window.scrollTo(0, 0);
    }
    // Reset de scroll em contêineres com overflow próprio (ex.: aside da Discover)
    document.querySelectorAll("[data-scroll-root]").forEach((el) => {
      el.scrollTop = 0;
    });
  }, [pathname, search, hash]);
  return null;
}
